<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="3"
		/>
			<multiSelectInput 
			:flds="$localStorage.get('degrees').data"
			label="گروه آموزشی"
			@input="(e) => { val.value.degrees = e.toString(); p_sav('degrees'); }"
			:value="val.value.degrees"
			/>
		<multiSelectInput
		:flds="category_data()" 
		:value="val.value.category" 
		@input="(e) => { val.value.category = e.toString(); p_sav('category'); }"
		label="موضوع تدریس یا تخصص" 
		/>
		<p>			
			نوع تدریس
		</p>
		<label>
			<input 
				type="checkbox" 
				v-model="val.value.online_teaching"
				@change="() => { p_sav('online_teaching'); }"
			/>
			آنلاین
		</label><br>
		<label>
			<input 
				type="checkbox"
				v-model="val.value.in_person_teaching"
				@change="() => { p_sav('in_person_teaching'); }"
			/>
			تدریس در محل کاربر
		</label><br>
		<label>
			<input 
				type="checkbox"
				v-model="val.value.teaching_home"
				@change="() => { p_sav('teaching_home'); }"
			/>
			تدریس در محل استاد
		</label>
		<textareaInput 
			label="آدرس محل تدریس"
			:value="val.value.address"
			@blurinputTxtFunc="(e) => { val.value.address = e; p_sav('address') }" 
			v-if="val.value.teaching_home==true || val.value.teaching_home==1"
		/>
		<file_cloud 
			label="بارگزاری تصاویر محل تدریس" 
			:error="false"
			:files="val.value.pic_location" 
			@chengeFile="(e) => { uploadTF('pic_location', e[0]);  }"
			@removeFile="(e) => { val.value.pic_location = e;  p_sav('pic_location'); }"
			v-if="val.value.teaching_home==true || val.value.teaching_home==1"
		/>
		<btn 
			class="pt-3 w-100" 
			textClass="w-100" 
			text="ذخیره نهایی"
			@clickMe="setPage();"
		/>
	</div>
</template>

<script>
	import btn from "../../UI/button/btn.vue";
	import multiSelectInput from "../../UI/input/multiSelectInput.vue";
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import { indexFinder } from "../../assets/library/filter.js";
	import file_cloud from "../../UI/uploadFile/file_cloud.vue";
	import textareaInput from "../../UI/input/textareaInput.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";

	export default {
		name: 'teaching_information',
		data(){
			return {
				indexFinder: indexFinder,
				success_sm: success_sm,
				error: error,
				success: success,
				loading: loading,
			}
		},
		components: {
			btn,
			multi_step_progress,
			multiSelectInput,
			file_cloud,
			textareaInput,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){
			this.val.value.online_teaching = this.check_set('online_teaching');
			this.val.value.in_person_teaching = this.check_set('in_person_teaching');
			this.val.value.teaching_home = this.check_set('teaching_home');
		},
		methods:{
		check_set(fld){
			return (this.val.value[fld]==true || this.val.value[fld]==1 || this.val.value[fld]=='1')
		},
		//********************************************************** */
		arr_str_2_int(val){
			var v = val.split(',');
			var a = [];
			for (let i = 0; i < v.length; i++) {
				v[i] = parseInt(v[i]);
				if(v[i]>0){
					a.push(v[i]);
				}
			}
			return a;
		},
		//********************************************************** */
setPage(){
	if(this.val.value.category=='' || this.val.value.degrees=='' || !(this.val.value.teaching_home || this.val.value.in_person_teaching || this.val.value.online_teaching)  || (this.val.value.teaching_home &&  this.val.value.pic_location.length==0) ){
		this.error(this);
	}else{
		this.val.page = 6;
	}
},
			//********************************************************** */
			category_data(){
				let degrees = this.$localStorage.get('degrees').data;
				let category = [];
				for(let i=0; i<this.val.value.degrees.length; i++){
					let index = -1;
					index = this.indexFinder(degrees, this.val.value.degrees[i]);
					for(let j=0; j<degrees[index].category.length; j++ ){
						var new_category=true;
						for(let c=0; c<category.length; c++ ){
							if (category[c].id == degrees[index].category[j].id && new_category) {
								new_category =false;
							}
						}
						if (new_category) {
							category.push(degrees[index].category[j]);
						}
					}
				}
				return category;
			},
			//********************************************************** */
			p_sav(fild) {
				let f = (fild == "category") ? 'cats' : fild;
				let v = this.val.value[fild];
				if(this.val.value[fild] == true){
					v = 1;
				} else if(this.val.value[fild] == false){
					v = 0;
				}
				if(this.$localStorage.get('user')) {
					
					window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id, admin: this.$localStorage.get('user')}, function () {
					
					}, "json");
				} else {
					window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: f ,val: v, id: this.val.id}, function () {
					
					}, "json");
				}
				
			},
			
//********************************************** */
uploadTF(val, e, THIS = this) {
	// THIS.loading(THIS);
	var formData = new FormData();
	formData.append("file", e);
	formData.append("format", ["jpg", "jpeg", "png", "pdf"]);
	formData.append("idImg", "t_[DATE]_[RANDOM]");
	var xhttp = new XMLHttpRequest();
	xhttp.open("POST", window.upldurl, true);
	xhttp.onreadystatechange = function () {
		if (this.readyState == 4 && this.status == 200) {
			this.getVar = JSON.parse(this.responseText);
			if (this.getVar.response == 1) {
				let F = {
					fileName: this.getVar.filename,
					fileUpload: this.getVar.uploadFileName,
				};
				THIS.val.value[val].push(F);
				THIS.p_sav(val);
				THIS.success_sm(THIS);
			} else {
				THIS.error(THIS, "فرمت فایل باید jpg باشد");
			}
		}
	};
	xhttp.send(formData);
},
		}
	}
</script>
<style>

</style>
